import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=d79fce52&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=d79fce52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79fce52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d79fce52')) {
      api.createRecord('d79fce52', component.options)
    } else {
      api.reload('d79fce52', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=d79fce52&scoped=true", function () {
      api.rerender('d79fce52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/Main.vue"
export default component.exports